export interface AreaItem {
  name: string;
  postcodes: string;
  note: string;
  image: string;
  tint: string;
}

export const areas: AreaItem[] = [
  {
    name: "Islington",
    postcodes: "N1 · N7",
    note: "Home base — same-week slots most weeks.",
    tint: "bg-secondary-100",
    image:
      "https://readdy.ai/api/search-image?query=Quiet%20Islington%20London%20street%20with%20a%20row%20of%20Victorian%20terraced%20brick%20houses%2C%20black%20front%20doors%2C%20wrought%20iron%20railings%2C%20soft%20morning%20light%2C%20realistic%20editorial%20photography&width=560&height=720&seq=area-islington-01&orientation=portrait",
  },
  {
    name: "Highbury",
    postcodes: "N5",
    note: "Flats, terraces and small offices.",
    tint: "bg-accent-100",
    image:
      "https://readdy.ai/api/search-image?query=Peaceful%20Highbury%20London%20residential%20street%20with%20leafy%20trees%20and%20Georgian%20style%20brick%20homes%2C%20warm%20natural%20daylight%2C%20soft%20shadows%2C%20realistic%20editorial%20photography&width=560&height=720&seq=area-highbury-02&orientation=portrait",
  },
  {
    name: "Angel",
    postcodes: "N1",
    note: "Independent shops, cafés and studios.",
    tint: "bg-primary-100",
    image:
      "https://readdy.ai/api/search-image?query=Angel%20Islington%20London%20high%20street%20view%20with%20independent%20shopfronts%20and%20cafes%20at%20golden%20hour%2C%20soft%20warm%20light%2C%20realistic%20editorial%20photography&width=560&height=720&seq=area-angel-03&orientation=portrait",
  },
  {
    name: "Canonbury",
    postcodes: "N1",
    note: "Family homes and residential lofts.",
    tint: "bg-background-200",
    image:
      "https://readdy.ai/api/search-image?query=Canonbury%20London%20terraced%20brick%20homes%20on%20a%20quiet%20residential%20street%20with%20soft%20green%20trees%2C%20natural%20daylight%2C%20realistic%20editorial%20photography&width=560&height=720&seq=area-canonbury-04&orientation=portrait",
  },
];

export const nearbyRoads = [
  "Upper Street",
  "Essex Road",
  "Liverpool Road",
  "Caledonian Road",
  "Holloway Road",
  "St Paul's Road",
  "Highbury Grove",
  "Canonbury Road",
  "City Road",
  "Camden Passage",
];